import PrivacyPage from './PrivacyPage';

export default PrivacyPage;


// WEBPACK FOOTER //
// ./src/components/pages/PrivacyPage/index.js